import { CircularProgress, Grid2 } from "@mui/material";
import BillingStyle from "./AddonsBillingSummary.module.scss";
import { useEffect } from "react";
import CustomButton from "../../../../../../GlobalComponents/CustomButton/CustomButton";
import AddonDetails from "../AddonDetails/AddonDetails";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import { cashfreeSubscriptionSessionIdDecrypt } from "../../../../../../Utils/cashfree";
import { addons_names } from "../../../../../../Utils/roconConstants";

const AddonsBillingSummary = (props) => {
  const {
    navigate,
    billingType,
    matchingBillingData,
    country,
    billingSalePrice,
    isSingleSite,
    addonDetails,
    downgradePopup,
    noUpgradePopup,
    NoAddonPopup,
    WaitAddonPopup,
    setIsPaneOpen,
    disabled,
    formatIndianCurrency,
    basePlan,
    selectedOrg,
    orgId,
    plan,
    userDetails,
    isLoading,
    setIsLoading,
    storageSites = [],
    performanceSite,
  } = props;

  // Storage packs are bought per selected site, so the cost scales with the site count
  const storageSiteCount = storageSites.length;
  const storageSiteMultiplier = Math.max(storageSiteCount, 1);

  useEffect(() => {
    getStore().dispatch({
      type: Actions.API_GET_SEPCIFIC_PLAN,
      data: { orgId: orgId },
    });
  }, [orgId]);

  useEffect(() => {
    getStore().dispatch({
      type: Actions.API_ALL_PLANS,
      meta: {
        onSuccess: (data) => {
          let monthPlans = [];
          let yearPlans = [];
          data?.plans?.licenses?.map((license) => {
            if (
              license.licenseType !== "Community Edition Beta" &&
              license.licenseType !== "Custom" &&
              license.licenseType !== "To The Moon"
            ) {
              let monthPlan = {};
              let yearPlan = {};
              monthPlan.name = license.licenseType + " Monthly";
              yearPlan.name = license.licenseType + " Yearly";
              monthPlan.licenseType = license.licenseType;
              yearPlan.licenseType = license.licenseType;
              license.pricing?.map((price) => {
                if (license.isSingleSitePlan === false) {
                  if (price.billingType === "Monthly") {
                    monthPlan.price = `₹${formatIndianCurrency(
                      price.orginalPrice_INR
                    )} per Month`;
                    monthPlan.priceInDollars = `₹${formatIndianCurrency(
                      price.orginalPrice_INR
                    )}`;
                    monthPlan.priceId = price.stripePriceId;
                  } else {
                    yearPlan.price = `₹${formatIndianCurrency(
                      price.orginalPrice_INR
                    )} per Year`;
                    yearPlan.priceInDollars = `₹${formatIndianCurrency(
                      price.orginalPrice_INR
                    )}`;
                    yearPlan.priceId = price.stripePriceId;
                  }
                }
              });

              let limit = parseInt(
                license.features?.filter(
                  (feature) => feature.type === "NUM_SITES"
                )[0]?.limitOrAvailablity
              );
              monthPlan.numberOfSites = limit;
              yearPlan.numberOfSites = limit;
              monthPlans.push(monthPlan);
              yearPlans.push(yearPlan);
            }
          });
          let addonsData = [];
          // let tempPriceIds = null;
          // let tempPerformPriceId = null;
          // let tempPrice = null;
          // let tempPerformPrice = null;
          // let tempStagingPrice = null;
          data?.features?.licenses?.map((license) => {
            let addOnDetails = {};
            addOnDetails.name = license.licenseType;
            addOnDetails.price = license.pricing[0].orginalPrice_INR;
            addOnDetails.priceId = license.pricing[0].stripePriceId;
            addOnDetails.billingType = license.pricing[0].billingType;
            addonsData.push(addOnDetails);

            // if (addOnDetails.name === "Additional Site") {
            //   tempPriceIds = addOnDetails.priceId;
            //   tempPrice = addOnDetails.price;
            // } else if (addOnDetails.name === "Performance Sites") {
            //   tempPerformPriceId = addOnDetails.priceId;
            //   tempPerformPrice = addOnDetails.price;
            // } else if (addOnDetails.name === "Staging") {
            //   tempPerformPriceId = addOnDetails.priceId;
            //   tempPerformPrice = addOnDetails.price;
            // }
          });
        },
      },
    });
  }, []);

  const formattedDate = (() => {
    const currentDate = new Date();
    const nextChargeDate = new Date(currentDate);
    if (billingType === "Monthly") {
      nextChargeDate.setMonth(nextChargeDate.getMonth() + 1);
    } else if (billingType === "Yearly") {
      nextChargeDate.setFullYear(nextChargeDate.getFullYear() + 1);
    }
    return nextChargeDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  })();

  let additionalCost = 0;

  // unit price of an add-on (salePrice / salePriceInr), shared by the total and the storage line
  const addonUnitCost = (addon) =>
    typeof addon.addonCost === "string"
      ? parseFloat(addon.addonCost.replace("$", ""))
      : addon.addonCost;

  const totalAddonCost = addonDetails?.reduce((total, addon) => {
    const cost = addonUnitCost(addon);

    // Calculate additional cost based on the slider value for "Staging"
    if (addon.addonType === "Staging") {
      switch (addon.addonCount) {
        case 15:
          if (country === "USA") {
            additionalCost = addon.addonCost + 0;
          } else {
            additionalCost = addon.addonCost + 0;
          }
          break;
        case 30:
          if (country === "USA") {
            additionalCost = addon.addonCost + 1;
          } else {
            additionalCost = addon.addonCost + 50;
          }
          break;
        case 45:
          if (country === "USA") {
            additionalCost = addon.addonCost + 2;
          } else {
            additionalCost = addon.addonCost + 100;
          }
          break;
        case 60:
          if (country === "USA") {
            additionalCost = addon.addonCost + 3;
          } else {
            additionalCost = addon.addonCost + 150;
          }
          break;
        case 75:
          if (country === "USA") {
            additionalCost = addon.addonCost + 4;
          } else {
            additionalCost = addon.addonCost + 200;
          }
          break;
        default:
          additionalCost = 0;
      }
    }

    return (
      total +
      (addon.addonType === "Staging"
        ? additionalCost
        : addon.addonType === addons_names.STORAGE
        ? cost * addon.addonCount * storageSiteMultiplier
        : cost * addon.addonCount)
    );
  }, 0);

  const gstAddonAmount = totalAddonCost * 0.18;
  const subtotalAddon = totalAddonCost;

  const totalAddonAmount =
    country === "USA" ? subtotalAddon : subtotalAddon + gstAddonAmount;

  // storage is a one-time purchase (own checkout below), never part of the add-on subscription
  const cartDetails = addonDetails
    ?.filter(
      (addon) =>
        addon.addonType !== addons_names.WAF &&
        addon.addonType !== addons_names.STAGING &&
        addon.addonType !== addons_names.STORAGE &&
        addon.addonType !== addons_names.PERFORMANCE_UPGRADE
    )
    ?.filter(
      (addon) => (addon.addonCount || 0) > 0 || (addon.existingAddons || 0) > 0
    )
    ?.map((addon) => ({
      priceId: addon.stripePriceId,
      quantity: (addon.addonCount || 0) + (addon.existingAddons || 0),
      price: parseInt(addon.addonCost, 10),
    }));

  const existingAddonsPlan = addonDetails
    ?.filter(
      (addon) =>
        addon.existingAddons > 0 &&
        addon.addonType !== addons_names.WAF &&
        addon.addonType !== addons_names.STAGING &&
        addon.addonType !== addons_names.STORAGE &&
        addon.addonType !== addons_names.PERFORMANCE_UPGRADE
    )
    ?.map((addon) => ({
      priceId: addon.stripePriceId,
      quantity: addon.addonCount + addon.existingAddons,
      price: parseInt(addon.addonCost, 10),
    }));

  const baseSingleSitePlan = Array.isArray(plan)
    ? plan.filter(
        (plan) => plan.basePlan === true && plan.isSingleSite === true
      )
    : [];

  const basePlanData = Array.isArray(plan)
    ? plan.filter((plan) => plan.basePlan === true)
    : [];

  function createAddon() {
    setIsLoading(true);
    getStore().dispatch({
      type: Actions.API_FETCH_STATUS,
      data: {
        orgId: orgId ? orgId : -1,
        basePlan: false,
        addon: true,
      },
      meta: {
        onSuccess: (fetchStatus) => {
          if (fetchStatus) {
            if (baseSingleSitePlan?.length > 0) {
              setIsLoading(false);
              NoAddonPopup();
              return;
            }

            if (country === "USA") {
              if (existingAddonsPlan?.length > 0) {
                getStore().dispatch({
                  type: Actions.GET_STRIPE_UPDATE_ADDONS,
                  data: {
                    orgId: orgId ? orgId : -1,
                    planAddOns:
                      cartDetails?.map((addon) => ({
                        priceId: addon.priceId,
                        quantity: addon.quantity,
                        subscriptionItem: "",
                      })) || [],
                    priceId: matchingBillingData?.stripePriceId || "",
                  },
                  meta: {
                    onSuccess: (data) => {
                      setIsLoading(false);
                      navigate(
                        `/account/${
                          selectedOrg?.orgId ? selectedOrg?.orgId : -1
                        }/dashboard`
                      );
                      const newLink = data?.link;

                      if (typeof newLink === "string") {
                        window.open(newLink, "_blank");
                      }
                    },
                    onError: () => {
                      setIsLoading(false);
                    },
                  },
                });
              } else {
                getStore().dispatch({
                  type: Actions.GET_STRIPE_CREATE_SUBSCRIPTION,
                  data: {
                    checkoutPayload: {
                      address: matchingBillingData?.address || {},
                      couponId: matchingBillingData?.couponId || "",
                      paymentMethodRequest: {
                        cardNumber: "",
                        cvc: "",
                        expMonth: "",
                        expYear: "",
                        orgId: orgId ? orgId : -1,
                      },
                      productDetailsRequests: {
                        orgId: orgId ? orgId : -1,
                        planAddOns:
                          cartDetails?.map((addon) => ({
                            priceId: addon.priceId,
                            quantity: addon.quantity,
                            subscriptionItem: "",
                          })) || [],
                        priceId: matchingBillingData?.stripePriceId || "",
                      },
                    },
                    couponId: "",
                    orgId: orgId ? orgId : -1,
                    priceId: matchingBillingData?.stripePriceId || "",
                  },
                  meta: {
                    onSuccess: (data) => {
                      setIsLoading(false);
                      getStore().dispatch({
                        type: Actions.SET_PLAN,
                        data: {
                          plan: true,
                        },
                      });
                      navigate(
                        `/account/${
                          selectedOrg?.orgId ? selectedOrg?.orgId : -1
                        }/dashboard`
                      );
                      const newLink = data?.link;

                      if (typeof newLink === "string") {
                        window.open(newLink, "_blank");
                      }
                    },
                    onError: () => {
                      setIsLoading(false);
                    },
                  },
                });
              }
            } else {
              getStore().dispatch({
                type: Actions.API_CREATE_ADDON_SUBSCRIPTION,
                data: {
                  orgId: orgId ? orgId : -1,
                  cartDetails,
                },
                meta: {
                  onSuccess: (data) => {
                    if (data === null) {
                      downgradePopup();
                      setIsPaneOpen(false);
                    } else {
                      navigate(
                        `/account/${
                          selectedOrg?.orgId ? selectedOrg?.orgId : -1
                        }/dashboard`
                      );
                      const cleanedData = data.replace(/\\/g, "");
                      cashfreeSubscriptionSessionIdDecrypt(cleanedData);
                      setIsLoading(false);
                    }
                  },
                  onError: () => {
                    noUpgradePopup();
                    setIsLoading(false);
                    setIsPaneOpen(false);
                    navigate(
                      `/account/${
                        selectedOrg?.orgId ? selectedOrg?.orgId : -1
                      }/dashboard`
                    );
                  },
                },
              });
            }
          } else {
            setIsLoading(false);
            WaitAddonPopup();
          }
        },
        onError: () => {
          setIsLoading(false);
          WaitAddonPopup();
        },
      },
    });
  }

  const stagingCount = addonDetails?.filter(
    (addon) => addon.addonType === "Staging"
  )[0]?.addonCount;

  const stagingPriceId = addonDetails?.filter(
    (addon) => addon.addonType === "Staging"
  )[0]?.stripePriceId;

  function processPayment(paymentType) {
    setIsLoading(true);

    const actionType =
      paymentType === "stripe"
        ? Actions.API_PAY_STAGING_STRIPE
        : Actions.API_PAY_STAGING_CASHFREE;

    getStore().dispatch({
      type: actionType,
      data: {
        orgId,
        quantity: stagingCount,
        priceId: stagingPriceId,
      },
      meta: {
        onSuccess: (data) => {
          const newLink = data.replace(/\\/g, "");

          if (typeof newLink === "string") {
            window.open(newLink, "_blank");
          }
          setIsLoading(false);
        },
        onError: () => {
          setIsLoading(false);
          setIsPaneOpen(false);
        },
      },
    });
  }

  function buyStaging() {
    const paymentType =
      orgId !== -1
        ? selectedOrg?.country === "USA"
          ? "stripe"
          : "cashfree"
        : userDetails?.country === "USA"
        ? "stripe"
        : "cashfree";
    processPayment(paymentType);
  }

  const storageAddon = addonDetails?.find(
    (addon) => addon.addonType === addons_names.STORAGE
  );
  // packs per site; every selected site gets the same packs
  const storageCount = storageAddon?.addonCount || 0;
  const storageGb = storageCount * (storageAddon?.packGb || 0);
  // same cost x packs x sites the total above uses (GST is in the GST row)
  const storageCost = storageAddon
    ? addonUnitCost(storageAddon) * storageCount * storageSiteMultiplier
    : 0;
  const storageMissingSite = storageCount > 0 && storageSiteCount === 0;
  const storageSitesLabel =
    storageSiteCount === 0
      ? "select a site"
      : storageSiteCount === 1
      ? storageSites[0].siteName
      : `${storageSiteCount} sites`;

  // Performance upgrade: one-time, one site, quantity always 1
  const performanceUpgradeAddon = addonDetails?.find(
    (addon) => addon.addonType === addons_names.PERFORMANCE_UPGRADE
  );
  const performanceUpgradeCount = performanceUpgradeAddon?.addonCount || 0;
  const performanceUpgradeCost = performanceUpgradeAddon
    ? addonUnitCost(performanceUpgradeAddon) * performanceUpgradeCount
    : 0;
  const performanceMissingSite =
    performanceUpgradeCount > 0 && !performanceSite?.siteId;

  // One-time performance upgrade checkout for the selected EBS site, same flow as storage
  function buyPerformanceUpgrade() {
    if (performanceMissingSite) {
      return;
    }
    const paymentType =
      orgId !== -1
        ? selectedOrg?.country === "USA"
          ? "stripe"
          : "cashfree"
        : userDetails?.country === "USA"
        ? "stripe"
        : "cashfree";
    setIsLoading(true);
    getStore().dispatch({
      type:
        paymentType === "stripe"
          ? Actions.API_PAY_PERFORMANCE_UPGRADE_STRIPE
          : Actions.API_PAY_PERFORMANCE_UPGRADE_CASHFREE,
      data: {
        orgId: orgId ? orgId : -1,
        priceId: performanceUpgradeAddon?.stripePriceId,
        siteId: performanceSite?.siteId,
      },
      meta: {
        onSuccess: (data) => {
          const newLink = data.replace(/\\/g, "");

          if (typeof newLink === "string") {
            window.open(newLink, "_blank");
          }
          setIsLoading(false);
        },
        onError: () => {
          setIsLoading(false);
        },
      },
    });
  }

  // One-time storage checkout for the selected EBS sites, like staging (Stripe URL / Cashfree link)
  function buyStorage() {
    if (storageMissingSite) {
      return;
    }
    const paymentType =
      orgId !== -1
        ? selectedOrg?.country === "USA"
          ? "stripe"
          : "cashfree"
        : userDetails?.country === "USA"
        ? "stripe"
        : "cashfree";
    setIsLoading(true);
    getStore().dispatch({
      type:
        paymentType === "stripe"
          ? Actions.API_PAY_STORAGE_STRIPE
          : Actions.API_PAY_STORAGE_CASHFREE,
      data: {
        orgId: orgId ? orgId : -1,
        quantity: storageCount,
        priceId: storageAddon?.stripePriceId,
        siteIds: storageSites.map((site) => site.siteId).join(","),
      },
      meta: {
        onSuccess: (data) => {
          const newLink = data.replace(/\\/g, "");

          if (typeof newLink === "string") {
            window.open(newLink, "_blank");
          }
          setIsLoading(false);
        },
        onError: () => {
          setIsLoading(false);
        },
      },
    });
  }

  return (
    <>
      <Grid2 className={BillingStyle.AddonsBillingSummary}>
        <Grid2
          className={`${BillingStyle.height} ${
            country === "India" ? BillingStyle.India : ""
          }`}
        >
          <Grid2 className={BillingStyle.headerTitle}>Plan Summary</Grid2>
          <Grid2 className={BillingStyle.noLineBlack} />
          <Grid2 className={BillingStyle.headerContainer}>
            <Grid2 className={BillingStyle.planHeader}>
              <Grid2 className={BillingStyle.planLabelRow}>
                <Grid2 className={BillingStyle.planLabel}>
                  {`${baseSingleSitePlan.length > 0 ? "SS" : "MS"} - ${
                    basePlan?.licenseType
                  }`}
                </Grid2>
                <Grid2 className={BillingStyle.planTypeLabel}>
                  {basePlanData[0]?.billingType === "Monthly"
                    ? "(Monthly Plan)"
                    : "(Yearly Plan)"}
                </Grid2>
              </Grid2>
              <Grid2 className={BillingStyle.priceHeader}>
                <Grid2 className={BillingStyle.planLabel}>
                  {country === "India" ? `₹` : `$`}
                  {formatIndianCurrency(billingSalePrice)}/
                </Grid2>
                <Grid2 className={BillingStyle.planTypeLabel}>
                  {basePlanData[0]?.billingType === "Monthly" ? "mon" : "yr"}
                </Grid2>
              </Grid2>
            </Grid2>
            <Grid2 className={BillingStyle.planHeader}>
              <Grid2 className={BillingStyle.planTypeLabel}>
                {basePlanData[0]?.featureDetails?.[0]?.limitOrAvailablity} Sites
              </Grid2>
              <Grid2 className={BillingStyle.dateFormat}>
                Next Bill {"  "}
                {formattedDate}
              </Grid2>
            </Grid2>
          </Grid2>

          <Grid2 className={BillingStyle.noLineBlack} />

          <AddonDetails
            addonDetails={addonDetails?.filter(
              (addon) =>
                addon.addonType !== addons_names.STORAGE &&
                addon.addonType !== addons_names.PERFORMANCE_UPGRADE
            )}
            country={country}
            orgId={orgId}
            isSingleSite={isSingleSite}
          />

          {storageCount > 0 && (
            <Grid2 className={BillingStyle.planHeader}>
              <Grid2 className={BillingStyle.planLabel1}>
                {`Storage +${storageGb} GB${
                  storageSiteCount > 1 ? " each" : ""
                } - ${storageSitesLabel}`}
              </Grid2>
              <Grid2 className={BillingStyle.planLabel1}>
                {`${country === "India" ? "₹" : "$"}${formatIndianCurrency(
                  storageCost
                )} (one-time)`}
              </Grid2>
            </Grid2>
          )}

          {performanceUpgradeCount > 0 && (
            <Grid2 className={BillingStyle.planHeader}>
              <Grid2 className={BillingStyle.planLabel1}>
                {`Performance Upgrade - ${
                  performanceSite?.siteName || "select a site"
                }`}
              </Grid2>
              <Grid2 className={BillingStyle.planLabel1}>
                {`${country === "India" ? "₹" : "$"}${formatIndianCurrency(
                  performanceUpgradeCost
                )} (one-time)`}
              </Grid2>
            </Grid2>
          )}

          {country === "India" && (
            <Grid2 className={BillingStyle.planHeader}>
              <Grid2 className={BillingStyle.planLabel1}>GST (18%)</Grid2>
              <Grid2 className={BillingStyle.priceHeader}>
                <Grid2 className={BillingStyle.planLabel1}>
                  {`${country === "India" ? "₹" : "$"}${formatIndianCurrency(
                    gstAddonAmount
                  )}/`}
                </Grid2>
                <Grid2 className={BillingStyle.planTypeLabel}>
                  {billingType === "Monthly" ? "mon" : "yr"}
                </Grid2>
              </Grid2>
            </Grid2>
          )}

          {/* Total Calculation */}
          <Grid2 className={BillingStyle.planHeader}>
            <Grid2 className={BillingStyle.planTotalLabel}>Total</Grid2>
            <Grid2 className={BillingStyle.priceHeader}>
              <Grid2 className={BillingStyle.planTotalLabel}>
                {`${country === "India" ? "₹" : "$"}${formatIndianCurrency(
                  totalAddonAmount.toFixed(2)
                )}/`}
              </Grid2>
              <Grid2 className={BillingStyle.planTypeLabel}>
                {storageCount > 0 || performanceUpgradeCount > 0
                  ? "one-time"
                  : billingType === "Monthly"
                  ? "mon"
                  : "yr"}
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>

        <Grid2 className={BillingStyle.container}>
          <Grid2>
            {country === "USA" ? (
              <Grid2 className={BillingStyle.planTypeLabel}>
                Your order may attract local taxes according to the billing
                information you give. The total cost might be different from the
                amount indicated here and will appear on your checkout.
              </Grid2>
            ) : (
              <Grid2 className={BillingStyle.planTypeLabel}>
                Displayed amount at checkout may reflects the amount for your
                next billing cycle. However, you will only be charged the amount
                shown above within the next 48 hrs. You may cancel your plan at
                any time.
              </Grid2>
            )}
          </Grid2>
          <Grid2 className={BillingStyle.flexboxButtton}>
            <CustomButton
              disabled={disabled || storageMissingSite || performanceMissingSite}
              className={BillingStyle.planButton}
              onClick={
                performanceUpgradeCount > 0
                  ? buyPerformanceUpgrade
                  : storageCount > 0
                  ? buyStorage
                  : stagingCount > 0
                  ? buyStaging
                  : createAddon
              }
            >
              {isLoading ? (
                <CircularProgress size={30} color={"inherit"} />
              ) : country === "India" && plan?.length === 0 ? (
                "Continue"
              ) : (
                "Pay Now"
              )}
            </CustomButton>
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
};

export default AddonsBillingSummary;
